module.exports = __webpack_public_path__ + "img/4.c252fd80.svg";